/**
 * Convert all the values of the object to the extra unit
 * @param {object} obj
 * @param {object} coopConfig
 * @returns {string} the formatted value with the extra unit abbreviation
 */
const convertableUnitsObject = (obj, coopConfig, keys = []) => {
  if (coopConfig.hasAcopioUnitsExtra()) {
    const newObj = {};
    Object.keys(obj).forEach(key => {
      if (keys.length > 0) {
        if (keys.includes(key)) {
          newObj[key] = Number(obj[key]) * (coopConfig.acopioUnitsConversion()?.conversion || 1);
        } else {
          newObj[key] = obj[key];
        }
      } else {
        newObj[key] = Number(obj[key]) * (coopConfig.acopioUnitsConversion()?.conversion || 1);
      }
    });
    return newObj;
  }
  return obj;
};

export default convertableUnitsObject;
